"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var ListingReviewModel_1 = require("./ListingReviewModel");
var ListingRelatedListModel_1 = require("./ListingRelatedListModel");
var ListingReviewListModel = /** @class */ (function (_super) {
    __extends(ListingReviewListModel, _super);
    function ListingReviewListModel(listing) {
        return _super.call(this, listing) || this;
    }
    ListingReviewListModel.prototype._loadImpl = function () {
        return this.listingService.getListingReviews({ listingId: this.listing.id });
    };
    Object.defineProperty(ListingReviewListModel.prototype, "newReview", {
        get: function () {
            return this._newReview;
        },
        enumerable: true,
        configurable: true
    });
    ListingReviewListModel.prototype.add = function () {
        this._newReview = new ListingReviewModel_1.ListingReviewModel(this.listing);
    };
    ListingReviewListModel.prototype.cancelEdit = function () {
        this._newReview = undefined;
    };
    __decorate([
        mobx_1.observable
    ], ListingReviewListModel.prototype, "_newReview", void 0);
    __decorate([
        mobx_1.computed
    ], ListingReviewListModel.prototype, "newReview", null);
    __decorate([
        mobx_1.action
    ], ListingReviewListModel.prototype, "add", null);
    __decorate([
        mobx_1.action
    ], ListingReviewListModel.prototype, "cancelEdit", null);
    return ListingReviewListModel;
}(ListingRelatedListModel_1.ListingRelatedListModel));
exports.ListingReviewListModel = ListingReviewListModel;
